module.exports = __webpack_public_path__ + "img/icon_map_3.3dcfb680.png";